import { useEffect, useState } from 'react';
import { LoadedReportModule, ReportModuleRef, loadReportModule } from './loader';

export interface ReportModuleState {
  module: LoadedReportModule | null;
  loading: boolean;
  /** why a bundled report could not be loaded; null while loading or when it did */
  error: string | null;
}

/** The report behind a key, ready to render: its bundle version, fetched. */
export function useReportModule(ref: ReportModuleRef | null): ReportModuleState {
  const [state, setState] = useState<{ ref: ReportModuleRef | null; module: LoadedReportModule | null; error: string | null }>({ ref: null, module: null, error: null });

  useEffect(() => {
    if (!ref) return;
    let cancelled = false;
    loadReportModule(ref)
      .then((module) => { if (!cancelled) setState({ ref, module, error: null }); })
      .catch((error: unknown) => { if (!cancelled) setState({ ref, module: null, error: error instanceof Error ? error.message : String(error) }); });
    return () => { cancelled = true; };
  }, [ref?.key, ref?.bundleVersionId]);

  if (!ref) return { module: null, loading: false, error: null };
  if (!ref.bundleVersionId) return { module: null, loading: false, error: null };
  const current = state.ref?.key === ref.key && state.ref?.bundleVersionId === ref.bundleVersionId;
  return current ? { module: state.module, loading: false, error: state.error } : { module: null, loading: true, error: null };
}
